import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../../components/seo"
import { graphql } from "gatsby"
import Line from "../../images/line.svg"

const ReisenList = (props) => {
  var länder = []

  return (
    <ul className="list-ul">
      {props.reisen.map((reise) => {
        if (länder.includes(reise.node.land)) {
          var nichtAnzeigen = true
        }
        länder += reise.node.land

        return (
          <li className="reise">
            <div className={nichtAnzeigen ? "no-display" : "reise-land"}>
              {reise.node.land}
            </div>
            <div className="reise-card">
              <Link
                to={reise.node.land.toLowerCase() + "/" + reise.node.slug}
                className="reise-thumbnail"
              >
                <GatsbyImage
                  image={reise.node.heroImage.gatsbyImageData}
                  className="thumbnail-container"
                />
              </Link>

              <div className="reise-card-text">
                <h2>{reise.node.destination}</h2>
                <div className="kurzbeschreibung">
                  {reise.node.kurzbeschreibung}
                </div>
                <div className="buchen-button-big-list">
                  <Link
                    to={reise.node.land.toLowerCase() + "/" + reise.node.slug}
                    className="buchen-button-big-link buchen-button-big-link-segelkreuzfahrt-liste"
                  >
                    Zum Angebot
                  </Link>
                </div>
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

const SegelkreuzfahrtenPage = ({ data }) => {
  return (
    <Layout>
      <Seo title="Segelkreuzfahrten" />
      <div className="reisen-liste-headline">
        <h1>
          Segel
          <wbr />
          kreuz
          <wbr />
          fahrten
        </h1>
        <img className="line" src={Line} alt="Trennlinie"></img>
      </div>
      <div className="reisen-liste-container">
        <ReisenList reisen={data.segelkreuzfahrten.edges} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    segelkreuzfahrten: allContentfulReise(
      filter: { typ: { eq: "Segel-Kreuzfahrt" } }
      sort: { fields: land, order: ASC }
    ) {
      edges {
        node {
          land
          flagge
          destination
          kurzbeschreibung
          slug
          heroImage {
            gatsbyImageData(width: 735, layout: CONSTRAINED)
          }
        }
      }
    }
  }
`

export default SegelkreuzfahrtenPage
